import React, { useState, useEffect } from 'react';
import CommonModal from './CommonModal';

const AcceptOrderModal = ({ isOpen, action, onSubmit, onClose }) => {
  const [delayTime, setDelayTime] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const actionType = action?.actionType;

  useEffect(() => {
    if (isOpen) {
      setDelayTime('');
      setReason('');
      setError('');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    setError('');

    
    if (actionType === 'accept') {
      const delay = Number(delayTime);

      if (delayTime && (delay < 1 || delay > 180)) {
        setError('Delay must be between 1–180 minutes');
        return;
      }

      onSubmit({ delay_time: delay || 0 });
    }

    
    else if (actionType === 'reject') {
      if (!reason.trim()) {
        setError('Please provide a rejection reason');
        return;
      }
      onSubmit({ reason });
    }

    
    else if (actionType === 'cancel') {
      if (!reason.trim()) {
        setError('Please provide a cancellation reason');
        return;
      }
      onSubmit({ reason });
    }

    
    else if (actionType === 'ready') {
      onSubmit({});
    }
  };

  const getTitle = () => ({
    accept: 'Accept Order',
    reject: 'Reject Order',
    cancel: 'Cancel Order',
    ready: 'Mark Order Ready'
  }[actionType] || 'Order Action');

  const getButtonText = () => ({
    accept: 'Accept',
    reject: 'Reject',
    cancel: 'Cancel',
    ready: 'Mark Ready'
  }[actionType] || 'Submit');

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="orderAcceptModal">

      <div className="modal-header">
        <h5 className="modal-title">{getTitle()}</h5>

        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">

        {actionType === 'accept' && (
          <>
            <p className="text-info">This minutes will be added in due date.</p>
            <input
              type="number"
              className="form-control"
              value={delayTime}
              onChange={(e) => setDelayTime(e.target.value)}
              placeholder="Add delay minutes (optional)"
              min="1"
              max="180"
            />
          </>
        )}

        {(actionType === 'reject' || actionType === 'cancel') && (
          <textarea
            className="form-control"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={
              actionType === 'reject'
                ? 'Provide a reason for rejection'
                : 'Provide a reason for cancellation'
            }
          />
        )}

        {actionType === 'ready' && (
          <p className="text-info">
            Are you sure you want to mark this order as ready?
          </p>
        )}

        {error && <div className="text-danger mt-2">{error}</div>}
      </div>

      <div className="modal-footer">
        <button className="btn btn-primary" onClick={handleSubmit}>
          {getButtonText()}
        </button>

        <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>

    </CommonModal>
  );
};

export default AcceptOrderModal;